import api from '@/api'

export default {
  async getSitesCategoriesList(context, payload) {
    const organizationId = payload.organizationId
    const sitesIds = payload.sitesIds
    const response = await api.category.getSitesCategoriesList(
      organizationId,
      sitesIds
    )

    return response
  },

  async getSiteRules(context, payload) {
    const organizationId = payload?.organizationId
    const siteId = payload?.siteId
    const response = await api.category.getSiteRules(organizationId, siteId)

    return response
  },

  async getOrganizationRules(context, payload) {
    const organizationId = payload?.organizationId
    const response = await api.category.getOrganizationRules(organizationId)

    return response
  },

  async createSiteRule(context, payload) {
    const organizationId = payload?.organizationId
    const siteId = payload?.siteId
    const rule = payload.rule
    const response = await api.category.createSiteRule(
      organizationId,
      siteId,
      rule
    )

    return response
  },

  async createOrganizationRule(context, payload) {
    const organizationId = payload?.organizationId
    const rule = payload.rule
    const response = await api.category.createOrganizationRule(
      organizationId,

      rule
    )

    return response
  },

  async updateSiteRule(context, payload) {
    const organizationId = payload?.organizationId
    const siteId = payload?.siteId
    const ruleId = payload.ruleId
    const ruleData = payload.rule
    const response = await api.category.updateSiteRule(
      organizationId,
      siteId,
      ruleId,
      ruleData
    )

    return response
  },

  async updateOrganizationRule(context, payload) {
    const organizationId = payload?.organizationId
    const ruleId = payload.ruleId
    const ruleData = payload.rule
    const response = await api.category.updateOrganizationRule(
      organizationId,
      ruleId,
      ruleData
    )

    return response
  },

  async getOrganizationCatalog(context, payload) {
    const organizationId = payload.organizationId
    const response = await api.category.getOrganizationCatalog(organizationId)

    return response.data
  },

  async deleteOrganizationRule(context, payload) {
    const organizationId = payload.organizationId
    const ruleId = payload.ruleId
    const response = await api.category.removeOrganizationRule(
      organizationId,
      ruleId
    )

    return response.data
  },
}
